import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useEffect, useRef, useState } from 'react';
import { useMutableRef } from '@carnica/utils/hooks';
import { createHiddenNode, getTextWidth } from "./utils";
export var useInputWidth = function useInputWidth(_ref) {
  var onChangeProp = _ref.onChange,
    value = _ref.value,
    active = _ref.active;
  var fieldRef = useRef(null);
  var hiddenNodeRef = useRef(null);
  var valueRef = useMutableRef(value);
  var _useState = useState("".concat(value === null || value === void 0 ? void 0 : value.length, "px")),
    _useState2 = _slicedToArray(_useState, 2),
    inputWidth = _useState2[0],
    setInputWidth = _useState2[1];
  var resize = function resize(val) {
    var hiddenNode = !hiddenNodeRef.current ? createHiddenNode(fieldRef) : hiddenNodeRef.current;
    if (!hiddenNodeRef.current) {
      hiddenNodeRef.current = hiddenNode;
    }
    setInputWidth("".concat(getTextWidth(hiddenNodeRef.current, val !== null && val !== void 0 ? val : valueRef.current), "px"));
  };
  var onChange = function onChange(e) {
    if (value === undefined && active) {
      resize(e.target.value);
    }
    onChangeProp === null || onChangeProp === void 0 ? void 0 : onChangeProp(e);
  };
  useEffect(function () {
    if (active) {
      resize(value);
    }
  }, [value, active]);
  useEffect(function () {
    return function () {
      var _hiddenNodeRef$curren;
      (_hiddenNodeRef$curren = hiddenNodeRef.current) === null || _hiddenNodeRef$curren === void 0 ? void 0 : _hiddenNodeRef$curren.remove();
    };
  }, [active]);
  return {
    fieldRef: fieldRef,
    onChange: onChange,
    inputWidth: inputWidth
  };
};